<template>
  <f7-page class="close-picker" id="register-screen" @popup:open="">
    <f7-navbar>
      <f7-nav-center class="titleApp" sliding>
        <p class="logoHomepage"><img class="loginLogo" src="./../../assets/static/images/logo/moneyroad_green.svg"/></p>
      </f7-nav-center>
    </f7-navbar>

<div class="registerForm">
<div class="row">
  <div class="col-md-6 offset-md-3">
    <div class="pilotageTabButtonContainer pilotageTabButtonContainerRegister">
      <f7-grid no-gutter>
        <f7-col width="50" class="pilotageTabController">
          <f7-link class='pilotageLink' v-bind:class="{tabActive: currentRole === 'individual'}" tab-link=".tabIndividual" @click="changeCurrentRole('individual')" active>{{ $t('common.indiv') }}</f7-link>
        </f7-col>
        <f7-col width="50" class="pilotageTabController" disabled>
          <f7-link class='pilotageLink' style="background:#999;color:#fff !important" v-bind:class="{tabActive: currentRole === 'professional'}" tab-link=".tabProfessional" @click="changeCurrentRole('professional')">{{ $t('common.busnss') }}</f7-link>
        </f7-col>
      </f7-grid>
    </div>
    <f7-tabs>
      <f7-tab class="tabIndividual" active no-gutter>
        <div class="data-table card">
          <f7-list form>
            <f7-list-item>
              <f7-input name="First Name" :placeholder="register_FirstName" type="text" v-model="firstName_r"></f7-input>
            </f7-list-item>
            <f7-list-item>
              <f7-input name="Last Name" :placeholder="register_LastName" type="text" v-model="LastName_r"></f7-input>
            </f7-list-item>
            <f7-list-item>
              <f7-input name="Email" :placeholder="register_Email" type="email" v-model="email_r"></f7-input>
            </f7-list-item>
            <!-- <li class="item-content">
              <div class="item-inner">
                <div class="item-title">
                  <span v-if="this.country_r === ''">{{ $t('common.ctry') }}</span>
                  <span v-else>{{ country_r }}</span>
                </div>
                <div class="item-after">
                  <a href="#" data-picker=".countryListPicker" class="link open-picker button button-round button-inner-color">
                  {{ $t('common.slct') }}
                  </a>
                </div>
              </div>
            </li> -->
            <li>
              <form-dropdown-input
              :placeholderValue="$t('common.ctry')"
              :itemList="country"
              v-model="country_r"/>
            </li>
            <f7-list-item required v-if="displayPassword">
              <!-- TLV 20/01/2020 : autocomplete à "new password" pour empêcher l'auto complétion de chrome -->
              <f7-input name="Password" type="password" :placeholder="register_Password" v-model="password1_r" autocomplete='new-password'></f7-input>
              <i class="icon-eye_blind icon icon-password" @click="toggleVisibility"></i>
            </f7-list-item>
            <f7-list-item v-if="displayPassword">
              <f7-input name="Repeat Password" type="password" :placeholder="register_RepeatPassword" v-model="password2_r"></f7-input>
              <i class="icon-eye_blind icon icon-password" @click="toggleVisibility"></i>
            </f7-list-item>
          </f7-list>
        </div>
      </f7-tab>

      <f7-tab class="tabProfessional">
        <div class="data-table card">
          <f7-list form>
            <f7-list-item>
              <f7-input name="Company Name" :placeholder="register_CompanyName" type="text" v-model="companyName_r"></f7-input>
            </f7-list-item>
            <f7-list-item>
              <f7-input name="Company Number" :placeholder="register_CompanyNumber" type="text" v-model="companyNumber_r"></f7-input>
            </f7-list-item>
            <f7-list-item>
              <f7-input name="Email" :placeholder="register_Email" type="email" v-model="email_r"></f7-input>
            </f7-list-item>
            <li class="item-content">
              <div class="item-inner">
                <div class="item-title">
                  <span v-if="this.country_r2 === ''">{{ $t('common.ctry') }}</span>
                  <span v-else>{{ country_r2 }}</span>
                </div>
                <div class="item-after">
                  <a href="#" data-picker=".countryListPicker" class="link open-picker button button-round button-inner-color">
                  {{ $t('common.slct') }}
                  </a>
                </div>
              </div>
            </li>
            <f7-list-item required v-if="displayPassword">
              <f7-input name="Password" type="password" :placeholder="register_Password" v-model="password1_r"></f7-input>
              <i class="icon-eye_blind icon icon-password" @click="toggleVisibility"></i>
            </f7-list-item>
            <f7-list-item v-if="displayPassword">
              <f7-input name="Repeat Password" type="password" :placeholder="register_RepeatPassword" v-model="password2_r"></f7-input>
              <i class="icon-eye_blind icon icon-password" @click="toggleVisibility"></i>
            </f7-list-item>
          </f7-list>
        </div>
      </f7-tab>
    </f7-tabs>

    <div class="row mr-0 ml-0">
      <div class="col-md-4" style="padding-left:0;padding-right:0">
        <button class="milkyBlock w-100 font-weight-bold mr-0 ml-0" style="box-shadow:none;border:1px #12bcf1 solid;color:#12bcf1" title="Back to Login Page" @click="goBack()">
          {{ $t('common.bck') }}
        </button>
      </div>
      <div class="col-md-4" style="padding-left:0;padding-right:0">
        <button class="milkyBlock w-100 font-weight-bold mr-0 ml-0" style="box-shadow:none;border:1px #12bcf1 solid;color:#12bcf1" title="Register New User" @click="registerNewUser()">
          {{ $t('common.rgstr') }}
        </button>
      </div>
    </div>
    <div class="picker-modal countryListPicker">
      <div class="toolbar">
        <div class="toolbar-inner">
          <div class="left"></div>
          <div class="right">
            <a href="#" class="close-picker orangeBackground" @click="countryListPickerCloseButton">{{ $t('common.bck') }}</a>
          </div>
        </div>
      </div>
      <div class="picker-modal-inner scrollablePicker">
        <f7-searchbar id="searchCountry"
          cancel-link="Cancel"
          search-list=".countryList"
          placeholder="Search"
          @searchbar:search="onSearch"
          @searchbar:clear="onClear">
        </f7-searchbar>
        <div class="list-block countryList">
          <f7-list contacts class="countryList">
            <f7-list-group v-for="(group, key) in filteredCountries" :key="key">
              <f7-list-item :title="key" group-title></f7-list-item>
              <li v-for="country in group" :value="country">
                <label class="label-radio item-content" @click="countryListPickerCloseButton">
                  <input type="radio" name="countryPickerRadio" :value="country">
                  <div class="item-inner">
                    <div class="item-title">{{ country }}</div>
                  </div>
                </label>
              </li>
            </f7-list-group>
          </f7-list>
        </div>
      </div>
    </div>
  </div>
  </div>
  </div>
  </f7-page>
</template>

<script>
import moment from 'moment'
import {errorMessageAlert} from '@/helpers/alert'
import {validateEmail} from '@/helpers/validator'
import pageNavBar from '@/components/common/pageNavBar.vue'
import {loadPage} from '@/helpers/routing'
import formDropdownInput from '@/components/common/formDropdownInput.vue'

export default {
  components: {
    'page-nav-bar': pageNavBar,
    'form-dropdown-input': formDropdownInput
  },
  props: [
    'FirstName', 'LastName', 'Login', 'Password'
  ],
  data: function () {
    return {
      currentRole: 'individual',
      firstName_r: '',
      LastName_r: '',
      companyName_r: '',
      companyNumber_r: '',
      email_r: '',
      countryPicker: '',
      countryPicker2: '',
      country_r: '',
      country_r2: '',
      password1_r: '',
      password2_r: '',
      filterBy: '',
      userMessage: '',
      watcherFinished: false,
      watcherFlag: 'Did not enter to watcher',
      pubKey: 'NaN',
      privKey: 'NaN',
      registered: false,
      isPro: false,
      accountType: 'Individual',
      fileUpload: 'string',
      colStyle: 'text-align: center; padding-top:5px; padding-bottom:5px;',
      darkColStyle: 'background: #333; text-align: center; padding-top:5px; padding-bottom:5px;',
      country: ['Afghanistan', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegowina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo, the Democratic Republic of the', 'Cook Islands', 'Costa Rica', "Cote d'Ivoire", 'Croatia (Hrvatska)', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands (Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard and Mc Donald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran (Islamic Republic of)', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', "Korea, Democratic People's Republic of", 'Korea, Republic of', 'Kuwait', 'Kyrgyzstan', "Lao, People's Democratic Republic", 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libyan Arab Jamahiriya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia, The Former Yugoslav Republic of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States of', 'Moldova, Republic of', 'Monaco', 'Mongolia', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Romania', 'Russian Federation', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia (Slovak Republic)', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia and the South Sandwich Islands', 'Spain', 'Sri Lanka', 'St. Helena', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen Islands', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic', 'Taiwan, Province of China', 'Tajikistan', 'Tanzania, United Republic of', 'Thailand', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela', 'Vietnam', 'Virgin Islands (British)', 'Virgin Islands (U.S.)', 'Wallis and Futuna Islands', 'Western Sahara', 'Yemen', 'Yugoslavia', 'Zambia', 'Zimbabwe'],
      countryAlphaTable: {
        A: ['Afghanistan', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan'],
        B: ['Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegowina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi'],
        C: ['Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo, the Democratic Republic of the', 'Cook Islands', 'Costa Rica', "Cote d'Ivoire", 'Croatia (Hrvatska)', 'Cuba', 'Cyprus', 'Czech Republic'],
        D: ['Denmark', 'Djibouti', 'Dominica', 'Dominican Republic'],
        E: ['East Timor', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia'],
        F: ['Falkland Islands (Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories'],
        G: ['Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana'],
        H: ['Haiti', 'Heard and Mc Donald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary'],
        I: ['Iceland', 'India', 'Indonesia', 'Iran (Islamic Republic of)', 'Iraq', 'Ireland', 'Israel', 'Italy'],
        J: ['Jamaica', 'Japan', 'Jordan'],
        K: ['Kazakhstan', 'Kenya', 'Kiribati', "Korea, Democratic People's Republic of", 'Korea, Republic of', 'Kuwait', 'Kyrgyzstan'],
        L: ["Lao, People's Democratic Republic", 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libyan Arab Jamahiriya', 'Liechtenstein', 'Lithuania', 'Luxembourg'],
        M: ['Macau', 'Macedonia, The Former Yugoslav Republic of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States of', 'Moldova, Republic of', 'Monaco', 'Mongolia', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar'],
        N: ['Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway'],
        O: ['Oman'],
        P: ['Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Romania', 'Russian Federation', 'Rwanda'],
        S: ['Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia (Slovak Republic)', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia and the South Sandwich Islands', 'Spain', 'Sri Lanka', 'St. Helena', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen Islands', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic'],
        T: ['Taiwan, Province of China', 'Tajikistan', 'Tanzania, United Republic of', 'Thailand', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu'],
        U: ['Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan'],
        V: ['Vanuatu', 'Venezuela', 'Vietnam', 'Virgin Islands (British)', 'Virgin Islands (U.S.)'],
        W: ['Wallis and Futuna Islands', 'Western Sahara'],
        Y: ['Yemen', 'Yugoslavia'],
        Z: ['Zambia', 'Zimbabwe']
      },
      displayPassword: true
    }
  },
  created: function () {
    this.register_FirstName = this.$i18n.t('common.fist_nm')
    this.register_LastName = this.$i18n.t('common.lst_nm')
    this.register_Email = this.$i18n.t('common.eml')
    this.register_Password = this.$i18n.t('common.pwd')
    this.register_RepeatPassword = this.$i18n.t('common.rpt_pwd')
    this.register_CompanyName = this.$i18n.t('common.cmp_nm')
    this.register_CompanyNumber = this.$i18n.t('common.cmp_nb')
    // let that = this
    if (this.FirstName) {
      this.firstName_r = this.FirstName
    } else {
      this.firstName_r = ''
    }
    if (this.LastName) {
      this.LastName_r = this.LastName
    } else {
      this.LastName_r = ''
    }
    this.companyName_r = ''
    this.companyNumber_r = ''
    if (this.Login) {
      this.email_r = this.Login
    } else {
      this.email_r = ''
    }
    this.country_r = ''
    this.country_r2 = ''
    if (this.$engine.user.connectBy === 'vue-google-oauth2') {
      this.password1_r = this.Password
      this.password2_r = this.Password
      this.displayPassword = false
    } else {
      this.password1_r = ''
      this.password2_r = ''
    }
    this.$f7.params.swipePanel = false
  },
  computed: {
    filteredCountries () {
      let that = this
      let result = {}
      if (this.filterBy) {
        for (var k in that.countryAlphaTable) {
          for (var i = 0; i < that.countryAlphaTable[k].length; i++) {
            if (that.countryAlphaTable[k][i].toLowerCase().startsWith(this.filterBy.toLowerCase())) {
              if (!result.hasOwnProperty(k)) {
                result[k] = []
              }
              result[k].push(that.countryAlphaTable[k][i])
            }
          }
        }
        this.Dom7('li[class=hidden-by-searchbar]').each(function () {
          that.Dom7(this).removeClass('hidden-by-searchbar')
        })
        return result
      }

      return this.countryAlphaTable
    }
  },
  methods: {
    openCountryPicker (e) {
      e.stopPropagation()
      this.countryPicker.open()
    },
    openCountryPicker2 (e) {
      e.stopPropagation()
      this.countryPicker2.open()
    },
    createImage (file) {
      var reader = new FileReader()
      var vm = this

      reader.onload = (e) => {
        vm.fileUpload = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeImage: function (e) {
      this.fileUpload = ''
    },
    registerNewUser () {
      const that = this
      var type = ''
      if (that.isPro) {
        type = '1'
      } else {
        type = '2'
      }

      let countryFinal = ''
      if (this.currentRole === 'individual') {
        countryFinal = this.country_r
      } else {
        countryFinal = this.country_r2
      }

      if (that.password1_r !== that.password2_r) {
        that.$f7.alert('Passwords do not match', 'Error')
      } else if (that.isPro && that.password1_r === '') {
        that.$f7.alert('Password missing', 'Error')
      } else if (that.isPro && that.companyName_r === '') {
        that.$f7.alert('Company name missing', 'Error')
      } else if (that.isPro && that.companyNumber_r === '') {
        that.$f7.alert('Company number missing', 'Error')
      } else if (that.isPro && that.fileUpload === '') {
        that.$f7.alert('Company document missing', 'Error')
      } else if (!that.isPro && that.password1_r === '') {
        that.$f7.alert('Password missing', 'Error')
      } else if (!that.isPro && that.firstName_r === '') {
        that.$f7.alert('First name missing', 'Error')
      } else if (!that.isPro && that.LastName_r === '') {
        that.$f7.alert('Last name missing', 'Error')
      } else if (that.email_r === '') {
        that.$f7.alert('Email missing', 'Error')
      } else if (that.email_r.length > 0 && validateEmail(that.email_r) === null) {
        that.$f7.alert('Change the email address to a valid format', 'Invalid Email Address')
        return
      } else if (countryFinal === '') {
        that.$f7.alert('Country missing', 'Error')
      } else {
        this.$f7.showPreloader('Registering...')
        var connectBySend = ''
        if (that.$engine.user.connectBy === 'vue-google-oauth2') {
          connectBySend = 'vgo'
        } else {
          connectBySend = 'lpc'
        }
        this.$engine.auth.register({
          Type: type,
          First_name: that.firstName_r,
          Last_name: that.LastName_r,
          Login: that.email_r,
          Password: that.password1_r,
          Company_name: that.companyName_r,
          Company_number: that.companyNumber_r,
          Country: countryFinal,
          Document: that.fileUpload,
          Connect_by: connectBySend
        }).then(response => {
          that.$f7.hidePreloader()
          if (response.status === 200) {
            if (that.displayPassword) {
              // On redirige vers la page de connexion
              loadPage(that, {url: '/login/'})
            } else {
              // Comme on s'est déja connecté via Google, on lance directement l'authentification
              that.$f7.showPreloader('Signing in')
              var creds = {
                Login: that.email_r,
                Password: that.password1_r,
                ConnectBy: 'vgo'
              }
              let defaultServiceRegisteredAccount = 'Direct Debit'
              this.$engine.auth.login(creds)
              .then(resp => {
                // J'existe
                let that = this
                that.$engine.services
                .enroll(1, moment('2020-06-10', 'YYYY-MM-DD'))
                .then(response => {
                  if (response.status === 200) {
                    this.$bus.emit('service:change', defaultServiceRegisteredAccount)
                    this.$bus.emit('LogIn', true)
                    that.$f7.hidePreloader()
                    this.$bus.emit('refresh-cache-menu')
                    // let serviceInbox = '/payments/inbox/'
                    // loadPage(that, {url: serviceInbox})
                    // that.$f7.popup('#service-switcher-true')
                    if (this.$engine.user.getIsFirstLogin() === '1') {
                      // alert('direct payments')
                      this.$bus.emit('service:change', defaultServiceRegisteredAccount)
                      // loadPage(that, {url: '/payments/inbox/'})
                      that.$engine.services.payments.update(0, 1, 1,
                        {
                          statusWaiting: 1
                        }
                      )
                      .then(resp => {
                        if (resp.data.payments.length > 0) {
                          that.$engine.settings.set({clickedMessage: resp.data.payments[0]})
                          that.$engine.settings.set({msgFromInbox: true})
                          that.$engine.user.setIsFirstLogin('0')
                          loadPage(that, {url: '/directPayments/inbox/'})
                        } else {
                          loadPage(that, {url: '/directPayments/inbox/'})
                        }
                      })
                      .catch(error => {
                        errorMessageAlert(error, that)
                      })
                    } else {
                      switch (this.$engine.user.get().favourite_service) {
                        case '2' :
                          this.$bus.emit('service:change', 'Direct Debit')
                          loadPage(that, {url: '/directDebit/inbox/'})
                          break
                        case '6' :
                          this.$bus.emit('service:change', 'Direct Payments')
                          loadPage(that, {url: '/directPayments/inbox/'})
                          break
                        default :
                          this.$bus.emit('service:change', 'directPayments')
                          loadPage(that, {url: '/directPayments/inbox/'})
                      }
                    }
                  }
                }).catch(error => {
                  that.$f7.hidePreloader()
                  errorMessageAlert(error, that)
                })
              }).catch(() => {
                // On fail do something
                that.$f7.hidePreloader()
              })
            }
            that.registered = true
            if (that.displayPassword) {
              that.$f7.alert('An activation link has been sent to your email account', 'Registration Done')
            }
          }
        }).catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    choosePro () {
      this.isPro = true
      this.accountType = 'Professional'
    },
    chooseInd () {
      this.isPro = false
      this.accountType = 'Individual'
    },
    openAlert: function () {
      var self = this
      self.$f7.alert('Feature in progress', 'Not implemented')
    },
    changeCurrentRole (role) {
      this.$f7.closeModal('.countryListPicker.modal-in')
      if (this.currentRole !== role) {
        this.currentRole = role
        if (role === 'individual') {
          this.$$(this.$$('.tabIndividual')[this.$$('.tabIndividual').length - 1]).addClass('active')
          this.$$(this.$$('.tabProfessional')[this.$$('.tabProfessional').length - 1]).removeClass('active')
          this.isPro = false
        } else if (role === 'professional') {
          this.$$(this.$$('.tabProfessional')[this.$$('.tabProfessional').length - 1]).addClass('active')
          this.$$(this.$$('.tabIndividual')[this.$$('.tabIndividual').length - 1]).removeClass('active')
          this.isPro = true
        }
      }
    },
    countryListPickerCloseButton () {
      if (this.Dom7('input[name=countryPickerRadio]:checked').val() !== undefined) {
        this.country_r = this.Dom7('input[name=countryPickerRadio]:checked').val()
        this.country_r2 = this.Dom7('input[name=countryPickerRadio]:checked').val()
      }
      // TLV 04/12/2019 : Fermeture automatique de la liste après avoir choisi un pays
      this.$f7.closeModal('.countryListPicker.modal-in')
    },
    toggleVisibility ($event) {
      let that = this
      if (that.Dom7($event.target).hasClass('icon-eye_blind')) {
        that.Dom7($event.target).removeClass('icon-eye_blind')
        that.Dom7($event.target).addClass('icon-eye')
        that.Dom7($event.target).parent().find('input').prop('type', 'text')
      } else {
        that.Dom7($event.target).removeClass('icon-eye')
        that.Dom7($event.target).addClass('icon-eye_blind')
        that.Dom7($event.target).parent().find('input').prop('type', 'password')
      }
    },
    onSearch: function (query, found) {
      this.filterBy = query
    },
    onClear: function () {
      this.filterBy = ''
    },
    goBack: function () {
      loadPage(this, {url: '/login/'})
    }
  }
}
</script>

<style scoped>
.blueText {
  color: #12bcf1;
}
#appName {
  color: grey;
  font-weight: bold;
}
#searchCountry {
  margin-top: 0;
}
.icon-password {
  width: 28px;
  height: 28px;
}
.page-content {
  overflow: hidden;
}

.no-gutter, .card {
  margin-left: 0px;
  margin-right: 0px;
}

</style>



// WEBPACK FOOTER //
// CMRegister.vue?3d5f2ada